import React from 'react';

export default function DataQualityStackedBar({ validPct = 0, emptyPct = 0, invalidPct = 0 }) {
  return (
    <div className="w-full">
      <div className="w-full h-4 rounded-md overflow-hidden bg-gray-100 border border-gray-200 flex">
        <div className="bg-green-500" style={{ width: `${validPct}%` }} />
        <div className="bg-yellow-400" style={{ width: `${emptyPct}%` }} />
        <div className="bg-red-500" style={{ width: `${invalidPct}%` }} />
      </div>
      <div className="mt-2 flex gap-4 text-xs text-gray-700">
        <span>Valid {validPct.toFixed(2)}%</span>
        <span>Empty {emptyPct.toFixed(2)}%</span>
        <span>Invalid {invalidPct.toFixed(2)}%</span>
      </div>
    </div>
  );
}
